/**
 * 灵活的响应式适配方案
 * 基于 1920x1080 设计稿，适配各种屏幕尺寸和浏览器缩放
 */
(function flexible(window, document) {
  const docEl = document.documentElement;
  const dpr = window.devicePixelRatio || 1;

  // 设置 body 字体大小
  function setBodyFontSize() {
    if (document.body) {
      document.body.style.fontSize = 12 * dpr + 'px';
    } else {
      document.addEventListener('DOMContentLoaded', setBodyFontSize);
    }
  }
  setBodyFontSize();

  // 设置根元素字体大小
  function setRemUnit() {
    const clientWidth = docEl.clientWidth;
    
    // 设计稿宽度为 1920px
    const designWidth = 1920;
    
    // 计算缩放比例
    let rem = (clientWidth / designWidth) * 100;
    
    // 最小值限制，防止过小
    if (rem < 50) rem = 50;
    // 最大值限制，防止过大
    if (rem > 200) rem = 200;
    
    docEl.style.fontSize = rem + 'px';
    
    // 设置 CSS 变量，方便使用
    docEl.style.setProperty('--rem-scale', rem / 100);
  }

  setRemUnit();

  // 使用 requestAnimationFrame 优化性能
  let resizeTimer = null;
  function onResize() {
    if (resizeTimer) {
      window.cancelAnimationFrame(resizeTimer);
    }
    resizeTimer = window.requestAnimationFrame(setRemUnit);
  }

  // 监听窗口大小变化
  window.addEventListener('resize', onResize);
  
  // 监听页面显示（从后台切换回来时）
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      onResize();
    }
  });

  // 检测浏览器缩放
  let lastDpr = dpr;
  window.addEventListener('resize', function() {
    const currentDpr = window.devicePixelRatio || 1;
    if (currentDpr !== lastDpr) {
      lastDpr = currentDpr;
      setBodyFontSize();
    }
  });

  // 暴露 API 供外部使用
  window.rem = {
    setRemUnit,
    getRem: () => {
      return parseFloat(docEl.style.fontSize) || 100;
    }
  };
})(window, document);

// 设置设备像素比
document.documentElement.setAttribute('data-dpr', window.devicePixelRatio || 1);
